var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockBlue = function SvgClockBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1572A1",
    fillRule: "evenodd",
    d: "M7.111 2.667a5.333 5.333 0 1 0 0 10.666 5.333 5.333 0 0 0 0-10.666M.593 8A6.519 6.519 0 1 1 13.63 8 6.519 6.519 0 0 1 .593 8M7.11 3.852c.328 0 .593.265.593.592v3.19l2.043 1.021a.593.593 0 1 1-.53 1.06L6.847 8.53A.59.59 0 0 1 6.518 8V4.444c0-.327.265-.592.592-.592",
    clipRule: "evenodd"
  })));
};
export default SvgClockBlue;